<template>
  <div class="page">
    <div>
      <el-button type="primary" @click="opexportExcel" style="margin-bottom: 12px;">导出</el-button>
    </div>
    <div v-loading="loading" style="position: relative;width: 100%;height: calc(100vh - 160px);">
      <div id="luckysheet" style="margin:0px;padding:0px;position:absolute;width:100%;height:100%;left: 0px;top: 0px;z-index: 0;"></div>
    </div>
  </div>
</template>

<script>
import exportExcel from './toExcelData.js'
import { saveAs } from 'file-saver'
export default {
  data() {
    return {
      data: [],
      loading: false
    }
  },
  async activated() {
    let list = this.$route.params.list
    let down = this.$route.params.down
    if (list && list.length) {
      this.loading = true
      await Promise.all(
        list.map(async (row) => {
          if (row && row.providerQuoteCode && row.providerQuoteName) {
            const result = this.data.some((item) => item.name == row.providerQuoteName)
            if (result) {
				this.data.forEach((item, i) => {
					if(item.name == row.providerQuoteName){
						luckysheet.setSheetActive(i)
					}
				})			  
            } else {
              try {
                let datacrr = await this.getluckysheetData(row.providerQuoteCode, row.providerQuoteName)
                if (this.data.length) {
                  luckysheet.setSheetAdd({ sheetObject: datacrr })
                } else {
                  this.data.push(datacrr)
                  // 创建文档表格
                  luckysheet.create({
                    container: 'luckysheet', //luckysheet为容器id
                    lang: 'zh', // 设定表格语言
                    showinfobar: false, //是否显示顶部信息栏
                    data: this.data,
                    columnHeaderHeight: 30
                  })
                }
              } catch (error) {}
            }
          }
        })
      )
      this.loading = false
      if (down) this.opexportExcel() // 导出
    } else if (!this.data.length) {
      this.$store.commit('layout/removePageToName', this.$route.path)
      this.$router.push({ name: 'Quoted' })
    }
  },
  methods: {
    // 通过渠道信息获取sheet表数据
    async getluckysheetData(providerQuoteCode, providerQuoteName) {
      // 表格渠道数据
      let quoteDetails = await this.$api.consignorquotedetails(providerQuoteCode)
      // 兜底补充数据
      quoteDetails.itemList.forEach((item) => {
        if (!item.weightRange) {
          let result = ''
          if (item.goodsType === 2) result = '文件'
          if ((item.calcMode = 2)) {
            result += item.weightEnd + 'KG'
          } else {
            if (item.weightBegin == item.weightEnd) {
              result += item.weightBegin + 'KG'
            } else {
              if (item.weightBegin + item.weightUnit < item.weightEnd) {
                let weightBegin = ((item.weightBegin + item.weightUnit) / item.weightUnit).toFixed(0) * item.weightUnit
                result += weightBegin + '-' + item.weightEnd + 'KG'
                if (item.weightUnit != 1.0 && item.calcMode != 3) {
                  result += '/' + item.weightUnit + 'KG'
                }
              } else if ((item.calcMode = 3)) {
                result += item.WeightEnd + '-' + item.weightEnd + 'KG'
              } else {
                result += item.WeightEnd + 'KG'
              }
              if ((item.calcMode = 3)) {
                result += '续' + item.weightUnit + 'KG'
              }
            }
          }
          item.weightRange = result
        }
      })
      // 数据
      let celldata = [] // 数据信息
      let merge = {} // 合并单元格信息
      let rowlen = {} // 行高信息
      let columnlen = {} // 列宽信息
      let range = []
      let row = 0 // 顶点
      let column = 0 // 顶点
      /**
       * 头部
       */
      // 填充数据
      celldata.push({ r: 0, c: 0, v: { v: providerQuoteName, fs: 20, ht: 0 } })
      celldata.push({ r: 1, c: 0, v: { v: providerQuoteName + (quoteDetails.fuelInclude ? ',含燃油' : ',未含燃油') + ',多件重量计算方式:' + (quoteDetails.weightCalcRuleMultiPieces == 0 ? '按票' : quoteDetails.weightCalcRuleMultiPieces == 1 ? '按件0.5进位' : '按件不进位') + ',体积除:' + quoteDetails.volumeDiv + ',结算重量算法:' + (quoteDetails.weightCalcRule == 0 ? '实重与体积取大' : quoteDetails.weightCalcRule == 1 ? '(实重+体积)/2' : '不计体积') } })
      celldata.push({ r: 2, c: 0, v: { v: '更新时间:' + quoteDetails.lastUpdateTime + ',更新内容:' + quoteDetails.lastUpdateContent } })
      // 标题行高
      rowlen[0] = 50
      // 合并单元格
      merge['0_0'] = { r: 0, c: 0, rs: 1, cs: 8 }
      merge['1_0'] = { r: 1, c: 0, rs: 1, cs: 8 }
      merge['2_0'] = { r: 2, c: 0, rs: 1, cs: 8 }
      // 行偏移量
      row = row + 3
      /**
       * 表格
       */
      if (quoteDetails.quoteStyle == 1) {
        // 国家横向，重量竖向(一行行填充)
        let add = 0
        // 编号
        celldata.push({ r: row, c: 0, v: { v: '分区', bg: '#ddeddb', ht: 0 } })
        quoteDetails.zoneList.forEach((_, i) => {
          celldata.push({ r: row, c: i + 1, v: { v: i + 1, bg: '#ddeddb', ht: 0, vt: 1 } })
        })
        // 国家
        celldata.push({ r: row + 1, c: 0, v: { v: '国家及地区', bg: '#ddeddb', vt: 1 } })
        quoteDetails.zoneList.forEach((item, i) => {
          celldata.push({ r: row + 1, c: i + 1, v: { v: item ? item.destination.slice(0, -1).replace(/#/g, ',') : '', tb: 2, ht: 0, bg: '#ddeddb', ht: 0, vt: 1 } })
          rowlen[4] = 120 // 国家行高
          columnlen[0] = 300 // 分区列宽 附加费国家列宽
        })
        // 城市
        if (quoteDetails.cityCaption) {
          celldata.push({ r: row + 2 + add, c: 0, v: { v: '城市', bg: '#ddeddb', ht: 0 } })
          quoteDetails.zoneList.forEach((item, i) => {
            celldata.push({ r: row + 2 + add, c: i + 1, v: { v: item.city, bg: '#ddeddb', ht: 0 } })
          })
          add = add + 1
        }
        // 邮编
        if (quoteDetails.postCodeCaption) {
          celldata.push({ r: row + 2, c: 0, v: { v: '邮编', bg: '#ddeddb', ht: 0 } })
          quoteDetails.zoneList.forEach((item, i) => {
            celldata.push({ r: row + 2, c: i + 1, v: { v: item.postCode, bg: '#ddeddb', ht: 0 } })
          })
          add = add + 1
        }
        // 重量段
        quoteDetails.itemList.forEach((item, e) => {
          celldata.push({ r: row + 2 + add + e, c: 0, v: { v: item.weightRange, bg: '#ddeddb', ht: 0 } })
          quoteDetails.zoneList.forEach((_, i) => {
            if (i + 1 < 10) {
              celldata.push({ r: row + 2 + add + e, c: i + 1, v: { v: item['zone0' + (i + 1)] || '*', bg: '#ddeddb', ht: 0 } })
            } else {
              celldata.push({ r: row + 2 + add + e, c: i + 1, v: { v: item['zone' + (i + 1)] || '*', bg: '#ddeddb', ht: 0 } })
            }
          })
        })
        // 备注
        celldata.push({ r: row + 2 + add + quoteDetails.itemList.length, c: 0, v: { v: '备注', bg: '#ddeddb', ht: 0 } })
        quoteDetails.zoneList.forEach((item, i) => {
          celldata.push({ r: row + 2 + add + quoteDetails.itemList.length, c: i + 1, v: { v: item.remark, bg: '#ddeddb', ht: 0, vt: 1 } })
        })
        range.push({ row: [row, row + 2 + add + quoteDetails.itemList.length], column: [0, quoteDetails.zoneList.length] })
        // 偏移量
        row = row + 3 + add + quoteDetails.itemList.length
        column = 1 + quoteDetails.zoneList.length < 8 ? 8 : 1 + quoteDetails.zoneList.length
      } else {
        // 国家竖向，重量横向(一列列填充)
        let add = 0
        // 编号
        celldata.push({ r: row, c: 0, v: { v: '分区', bg: '#ddeddb', ht: 0 } })
        quoteDetails.zoneList.forEach((_, i) => {
          celldata.push({ r: row + i + 1, c: 0, v: { v: i + 1, bg: '#ddeddb', ht: 0 } })
        })
        // 国家
        celldata.push({ r: row, c: 1, v: { v: '国家及地区', bg: '#ddeddb', ht: 0, vt: 1 } })
        quoteDetails.zoneList.forEach((item, i) => {
          celldata.push({ r: row + i + 1, c: 1, v: { v: item.destination ? item.destination.slice(0, -1).replace(/#/g, ',') : '', tb: 2, vt: 0, bg: '#ddeddb', ht: 0, vt: 1 } })
          rowlen[row + i + 1] = 60 // 国家行高
          columnlen[1] = 300 // 国家列宽
        })
        // 城市
        if (quoteDetails.cityCaption) {
          celldata.push({ r: row, c: 2 + add, v: { v: '城市', bg: '#ddeddb', ht: 0 } })
          quoteDetails.zoneList.forEach((item, i) => {
            celldata.push({ r: row + i + 1, c: 2 + add, v: { v: item.city || '', bg: '#ddeddb', ht: 0 } })
          })
          add = add + 1
        }
        // 邮编
        if (quoteDetails.postCodeCaption) {
          celldata.push({ r: row, c: 2, v: { v: '邮编', bg: '#ddeddb', ht: 0 } })
          quoteDetails.zoneList.forEach((item, i) => {
            celldata.push({ r: row + i + 1, c: 2, v: { v: item.postCode || '', bg: '#ddeddb', ht: 0 } })
          })
          add = add + 1
        }
        // 重量段
        quoteDetails.itemList.forEach((item, e) => {
          celldata.push({ r: row, c: 2 + add + e, v: { v: item.weightRange, bg: '#ddeddb', ht: 0 } })
          quoteDetails.zoneList.forEach((_, i) => {
            if (i + 1 < 10) {
              celldata.push({ r: row + i + 1, c: 2 + add + e, v: { v: item['zone0' + (i + 1)] || '*', bg: '#ddeddb', ht: 0 } })
            } else {
              celldata.push({ r: row + i + 1, c: 2 + add + e, v: { v: item['zone' + (i + 1)] || '*', bg: '#ddeddb', ht: 0 } })
            }
          })
        })
        // 备注
        celldata.push({ r: row, c: 2 + add + quoteDetails.itemList.length, v: { v: '备注', bg: '#ddeddb', ht: 0 } })
        quoteDetails.zoneList.forEach((item, i) => {
          celldata.push({ r: row + i + 1, c: 2 + add + quoteDetails.itemList.length, v: { v: item.remark, bg: '#ddeddb' } })
        })
        range.push({ row: [row, row + quoteDetails.zoneList.length], column: [0, 2 + add + quoteDetails.itemList.length] })
        // 偏移量
        row = row + 1 + quoteDetails.zoneList.length
        column = 2 + add + quoteDetails.itemList.length < 8 ? 8 : 2 + add + quoteDetails.itemList.length
      }
      /**
       * 折扣加收
       */
      quoteDetails.disAddList.forEach((item) => {
        // 横向分段
        let text = item.disaddType == 1 ? '加收的金额需乘燃油费' : ''
        text = item.weightCeil ? (text ? text + '，' : text) + '加收元KG/的，重量取整计算' : text
        text = text ? '(' + text + ')' : text
        celldata.push({ r: row + 1, c: 0, v: { v: item.disaddName + ':' + text } })
        // 动态合并
        merge[row + 1 + '_0'] = {
          r: row + 1,
          c: 0,
          rs: 1,
          cs: 4
        }
        celldata.push({ r: row + 2, c: 0, v: { v: '国家及地区', bg: '#ddeddb', ht: 0 } })
        item.zoneList.forEach((e, i) => {
          // 竖向填充
          celldata.push({ r: row + 3 + i, c: 0, v: { v: e ? e.destination.slice(0, -1).replace(/#/g, ',') : '', tb: 2, vt: 0, bg: '#ddeddb', ht: 0 } })
        })
        // 分段数据
        item.itemList.forEach((e, x) => {
          celldata.push({ r: row + 2, c: 1 + x, v: { v: e.weightRange, bg: '#ddeddb', ht: 0 } })
          item.zoneList.forEach((_, i) => {
            if (i + 1 < 10) {
              celldata.push({ r: row + 3 + i, c: 1 + x, v: { v: e['zone0' + (i + 1)] || '*', bg: '#ddeddb', ht: 0 } })
            } else {
              celldata.push({ r: row + 3 + i, c: 1 + x, v: { v: e['zone' + (i + 1)] || '*', bg: '#ddeddb', ht: 0 } })
            }
          })
        })
        // 备注
        item.itemList.forEach((_) => {
          celldata.push({ r: row + 2, c: 1 + item.itemList.length, v: { v: '分区备注', bg: '#ddeddb', ht: 0 } })
          item.zoneList.forEach((_, i) => {
            if (i + 1 < 10) {
              celldata.push({ r: row + 3 + i, c: 1 + item.itemList.length, v: { v: '', bg: '#ddeddb', ht: 0 } })
            } else {
              celldata.push({ r: row + 3 + i, c: 1 + item.itemList.length, v: { v: '', bg: '#ddeddb', ht: 0 } })
            }
          })
        })
        range.push({ row: [row + 2, row + 3 + item.zoneList.length - 1], column: [0, 1 + item.itemList.length] })
        row = row + 3 + item.zoneList.length
      })
      /**
       * 折扣限制
       */
      celldata.push({ r: row + 1, c: 0, v: '加收限制:' })
      quoteDetails.limitRules.forEach((item, i) => {
        let text = ''
        if (item.feeType == 5) text += '提示'
        text += item.ruleRemark
        if (item.ruleRemark) text += '：'
        if (item.feeType == 1) text += '加收 '
        text += item.actionDesc
        text += '条件：' + item.conditionDesc
        celldata.push({ r: row + 2 + i, c: 0, v: text })
        // 动态合并
        merge[row + 2 + i + '_0'] = {
          r: row + 2 + i,
          c: 0,
          rs: 1,
          cs: 8
        }
      })
      celldata.push({ r: row + 3 + quoteDetails.limitRules.length, c: 0, v: { v: quoteDetails.providerQuoteRemark, tb: 2 } })
      merge[row + 3 + quoteDetails.limitRules.length + '_0'] = {
        r: row + 3 + quoteDetails.limitRules.length,
        c: 0,
        rs: 4,
        cs: 8
      }
      row = row + 3 + quoteDetails.limitRules.length + 4
      /**
       * 返回结构
       */
      let datacrr = {
        name: providerQuoteName,
        column,
        row,
        celldata,
        defaultRowHeight: 30,
        defaultColWidth: 150,
        config: {
          merge,
          rowlen,
          columnlen,
          borderInfo: [
            {
              rangeType: 'range',
              borderType: 'border-all',
              style: '1',
              color: '#000',
              range
            }
          ]
        }
      }
      return datacrr
    },
    // 导出
    async opexportExcel() {
      let luckysheetdata = luckysheet.getluckysheetfile()
      let blob = await exportExcel(luckysheetdata)
      saveAs(
        new Blob([blob], {
          type: 'application/octet-stream'
        }),
        '报价详情.xlsx'
      )
    }
  }
}
</script>

<style scoped>
</style>